export default __webpack_public_path__ + "static/media/down_arrow.f2f1dfe9.svg";